<template>
  <div v-if="showCookieNotice">
    <div class="cookie-notice-overlay">
    </div>
    <form class="cookie-notice cookie-preferences-form" @submit.prevent="confirm">
      <div class="cookie-notice__analytics">
        <h3>Marketing and analytics cookies</h3>

        <label class="toggle-switch"> <input
            v-model="analyticsAccepted"
            class="toggle-switch__chk"
            type="checkbox"
            name="analyticsAccepted"
            value="accepted"
            checked
            aria-checked="true"
            aria-label="Analytics cookies accepted" />
          <div class="toggle-switch__box">
            <div class="toggle-switch__offset"></div>
            <div class="toggle-switch__handle">
              <div class="toggle-switch__label" data-checked-text="On" data-unchecked-text="Off">

              </div>
            </div>
          </div>
        </label>
      </div>

      <div class="cookie-notice__content">
        <p>We use various tracking cookies to help us improve the user experience. If you wish you can switch these off. Read more about how we use cookies on our <a href="https://www.heurix.io/privacy-policy/">cookie policy page</a>.</p>
      </div>

      <button class="btn-cta" type="submit">
        Confirm

        <svg viewBox="0 0 32 32" class="cookie-notice__fingerprint">
          <g id="fingerprint">
            <path fill="#FFF" fill-rule="nonzero"
                  d="M18.7 4.1a14.3 14.3 0 00-7-1.7c-2.4 0-4.8.6-7 1.7-.2.2-.6.1-.8-.2-.1-.3 0-.7.3-.8a15.7 15.7 0 0115 0c.3.1.4.5.3.8-.1.2-.3.3-.6.3h-.2zM1 10.3H.7a.6.6 0 01-.2-.9c1.3-1.7 2.9-3 4.7-4 4-1.8 9-1.9 13 0 1.9 1 3.4 2.3 4.7 4 .2.2.1.6-.2.8-.3.2-.6.1-.8-.1a11.6 11.6 0 00-4.3-3.6 13.8 13.8 0 00-11.8 0c-1.7.9-3.1 2-4.3 3.6 0 .2-.2.2-.4.2zm8 14.2c-.1 0-.3 0-.4-.2-1.1-1-1.7-1.7-2.5-3.1A10 10 0 014.8 16c0-3.5 3.2-6.4 7.2-6.4s7.2 2.9 7.2 6.4c0 .3-.3.6-.7.6-.3 0-.6-.3-.6-.6 0-2.9-2.6-5.2-5.9-5.2-3.3 0-6 2.3-6 5.2 0 1.7.5 3.3 1.3 4.6.8 1.4 1.3 2 2.3 2.9.3.2.3.6 0 .8l-.5.2zm8.7-2c-1.5 0-2.9-.3-4-1-1.9-1.2-3-3.2-3-5.4 0-.3.2-.6.6-.6.4 0 .6.3.6.6 0 1.7 1 3.4 2.6 4.4.9.6 2 .9 3.2.9.3 0 .9 0 1.4-.2.3 0 .7.2.7.5.1.4-.1.7-.5.7-.7.2-1.4.2-1.6.2zm-2.2 2.8h-.2a10 10 0 01-4.7-2.6A8.7 8.7 0 018 16.4c0-2 1.7-3.6 3.9-3.6 2.1 0 3.9 1.6 3.9 3.6 0 1.3 1.1 2.3 2.6 2.3 1.4 0 2.6-1 2.6-2.3 0-4.6-4.1-8.3-9.1-8.3-3.6 0-6.9 2-8.3 4.9-.5 1-.8 2.1-.8 3.4 0 1 .1 2.4.9 4.4 0 .3 0 .6-.4.7-.3.2-.7 0-.8-.3a13 13 0 01-1-4.8c0-1.5.4-2.8 1-4C4 9.2 7.7 7 11.8 7c5.7 0 10.3 4.2 10.3 9.5 0 2-1.7 3.5-3.8 3.5-2.2 0-4-1.6-4-3.5 0-1.3-1-2.4-2.5-2.4s-2.6 1-2.6 2.4c0 2 .8 4 2.3 5.4a8.6 8.6 0 004.1 2.3c.4 0 .6.4.5.7-.1.3-.4.5-.6.5z" />
          </g>
        </svg>

        <span class="visually-hidden">Accept cookies/close</span>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'CookieNotice',

  data() {
    return {
      showCookieNotice: true,
      analyticsAccepted: true
    }
  },

  mounted() {
    let analyticsCookieAcceptanceStatus = this.$cookies.get("AnalyticsCookieAcceptanceStatus")
    this.showCookieNotice = !analyticsCookieAcceptanceStatus
    if (analyticsCookieAcceptanceStatus === 'declined') {
      this.removeAnalyticsCookies()
    }
  },

  methods: {
    confirm() {
      let response = this.analyticsAccepted ? 'accepted' : 'declined'
      this.$cookies.set('AnalyticsCookieAcceptanceStatus', response, "90d", null, process.env.NODE_ENV === 'production' ? "heurix.io" : "localhost")
      this.showCookieNotice = false
      if (response === 'declined') {
        this.$gtm.enable(false)
        this.removeAnalyticsCookies()
      }

      if (response === 'accepted') {
        this.$gtm.enable(true)
      }
    },
    getDomain() {
      let domainParts = window.location.hostname.split('.')
      if (domainParts.length > 2) {
        return '.' + domainParts[domainParts.length - 2] + '.' + domainParts[domainParts.length - 1]
      }
      return window.location.hostname
    },

    removeAnalyticsCookies() {
      if (window.ga) window.ga('remove')
      let keys = this.$cookies.keys()
      let domain = this.getDomain()
      for (let key in keys) {
        if (keys[key].startsWith('_g')) {
          this.$cookies.remove(keys[key])
          this.$cookies.remove(keys[key], null, domain)
        }
      }
    }
  }
}
</script>

<style>
</style>